export default [
    {
        path: '/enroll',
        name: 'enroll',
        redirect: '/enroll/statement',
        component: () => import('@/views/enroll'),
        meta: { title: '考试认证' },
        children: [
            {
                path: 'statement',
                name: 'statement',
                component: () => import('@/views/enroll/statement'),
                meta: { title: '法律声明', loginStatus: true }
            },
            {
                path: 'level/:level?',
                name: 'level',
                component: () => import('@/views/enroll/level'),
                meta: { title: '选择报名级别', loginStatus: true }
            },
            {
                path: 'info/:level/:id?',
                name: 'info',
                component: () => import('@/views/enroll/info'),
                meta: { title: '填写报名信息', loginStatus: true }
            },
            {
                path: 'education/:level/:id',
                name: 'education',
                component: () => import('@/views/enroll/education'),
                meta: { title: '填写报名信息', loginStatus: true }
            },
			{
			    path: 'societedu/:level/:id',
			    name: 'societedu',
			    component: () => import('@/views/enroll/societedu'),
			    meta: { title: '填写报名信息', loginStatus: true }
			},
            {
                path: 'work/:level/:id',
                name: 'work',
                component: () => import('@/views/enroll/work'),
                meta: { title: '填写报名信息', loginStatus: true }
            },
			{
			    path: 'societwork/:level/:id',
			    name: 'societwork',
			    component: () => import('@/views/enroll/societwork'),
			    meta: { title: '填写报名信息', loginStatus: true }
			},
            {
                path: 'explain/:level/:id',
                name: 'explain',
                component: () => import('@/views/enroll/explain'),
                meta: { title: '填写报名信息', loginStatus: true }
            },
            {
                path: 'preview/:level/:id',
                name: 'preview',
                component: () => import('@/views/enroll/preview'),
                meta: { title: '预览报名信息', loginStatus: true }
            },
            {
                path: 'place/:level/:id/:type?',
                name: 'place',
                component: () => import('@/views/enroll/place'),
                meta: { title: '选择考场', loginStatus: true }
            },
            {
                path: 'audit/:id?',
                name: 'audit',
                component: () => import('@/views/enroll/audit'),
                meta: { title: '信息审核', loginStatus: true }
            },
            {
                path: 'pay/:id',
                name: 'pay',
                component: () => import('@/views/enroll/pay'),
                meta: { title: '支付', loginStatus: true }
            },
			{
			    path: 'pays/:id',
			    name: 'pays',
			    component: () => import('@/views/enroll/pays'),
			    meta: { title: '支付', loginStatus: true }
			},
            {
                path: 'confirm/:id',
                name: 'confirm',
                component: () => import('@/views/enroll/confirm'),
                meta: { title: '考试确认', loginStatus: true }
            },
            
        ]
    },
    {
        path: '/result/:type',
        name: 'result',
        component: () => import('@/views/enroll/result'),
        meta: { title: '考试认证', loginStatus: true }
    },
    {
        path: '/details/:id',
        name: 'details',
        component: () => import('@/views/enroll/details'),
        meta: { title: '考试详情', loginStatus: true }
    },
]